if($('html[lang="cs"]')){
    backToShop = 'Zpět do obchodu';
    buyButton = 'Koupit';
    rowCategory = 'Kategorie';
    askButton = 'Poptat';
    nameAndSurname = 'Uživatelské jméno nebo e-mail';
    password = 'Heslo';
    favoriteURL = 'oblibene';
    detailButton = 'Detail';
    returnabilityText = 'Návratnost';
}   